module.exports = __webpack_public_path__ + "img/step-1.c08668a0.jpg";